import { useNews } from "./hook/useNews";
import { New } from "./New/New";
import { NewsBlock, NewsContainer, NewsTitle } from "./styled";
import { Link } from "react-router-dom";
import { Loader } from "../Loader/Loader";

export const News = () => {
  const { news, isLoading } = useNews();

  return (
    <NewsContainer>
      <NewsTitle>Новости школы</NewsTitle>
      {isLoading || !news ? (
        <Loader compact />
      ) : (
        <NewsBlock>
          {news.slice(0, 5).map((value: any) => (
            <Link key={value.slug} to={`/news/${value.slug}`}>
              <New props={value} />
            </Link>
          ))}
        </NewsBlock>
      )}
    </NewsContainer>
  );
};
